define([
	"dojo/_base/declare",
	"csi/action/AggregateController"
], function(declare,AggregateController) {

	return declare(AggregateController, {
		getFormData: function() {
			// summary: restrict selection to one at a time
			var	fd = this.inherited(arguments);
			fd.m_bSelectOne = true;
			return fd;
		},

		preProcess: function() {
			// summary: a little bit tricky here - need the action to work in the context of the MaterialSpec node;
			// if season list is currently empty, then context will be the Material; otherwise it will be a MaterialSeasonAvailability node
			var	ctx = this.getContext();
			var	spec = ctx.getContextNode();

			this.m_urlParent = this.m_urlNode = spec.$URL;

			// this is necessary so action will know what seasons are already selected
			ctx.cache.getChildren(spec, this.m_action.aggregateId, true);

			var seasonAvailLength = spec.SeasonAvailability.length;

			// use current switchboard selection as source node for new season
			if (seasonAvailLength > 0) {
			    this.urlAggregateClassSource = spec.SeasonAvailability[seasonAvailLength - 1];
			}

			this.inherited(arguments);
		}
	});
});